module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/toc#an"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ALTHOUGH THERE ARE")]), _vm._v(" vertical shafts which penetrate the London Underground from street level, and some which descend from higher than that, none is to be found in any building near Holborn Underground station, nor behind the Soane Museum, nor anywhere in the neighborhood of Lincoln’s Inn Fields.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is not possible to travel from Kensington High Street to Notting Hill Gate on the roof of a tube train car. Or if it is possible it would be too dangerous for any sane person of any age to contemplate.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The rest of the factual information in this book about London Transport Underground is true.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e150e1f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/an.vue
// module id = 81
// module chunks = 0